import { Divider, ListItem, Typography } from '@mui/material';
import React from 'react';
import { HorizontalBox, VerticalBox } from '../layout/BoxLayout';

export const ValueListItem: React.FC<{
  label: React.ReactNode;
  subLabel?: React.ReactNode;
  value: React.ReactNode;
  multiLine?: boolean;
  /** Show a long value in full: as soon as it no longer fits next to the label, it wraps to its own full-width line. */
  wrapValue?: boolean;
  dataTestId?: string;
}> = ({ label, subLabel, value, multiLine = false, wrapValue = false, dataTestId }) => {
  const Box = multiLine ? VerticalBox : HorizontalBox;

  // Replace hyphens with non-breaking hyphens to prevent unwanted line breaks in labels
  const processedLabel = typeof label === 'string' ? label.replaceAll('-', '\u2011') : label;

  return (
    <ListItem sx={{ '&:last-child .value-list-item-divider': { display: 'none' } }} data-test-id={dataTestId}>
      <VerticalBox sx={{ maxWidth: '100%', flexGrow: 1 }}>
        {/* rowGap 0 keeps a value that wrapped to its own line close to its label */}
        <Box
          sx={{ maxWidth: '100%', flexWrap: wrapValue ? 'wrap' : 'nowrap', gap: multiLine ? 0.5 : 2, rowGap: wrapValue ? 0 : undefined }}
        >
          <Typography
            variant="caption"
            sx={{
              color: 'text.secondary',
              flexGrow: 1,
            }}
          >
            {processedLabel}
            {subLabel && (
              <Typography
                variant="body2"
                sx={{
                  color: 'text.secondary',
                }}
              >
                {subLabel}
              </Typography>
            )}
          </Typography>
          <Typography
            noWrap={!wrapValue}
            variant="caption"
            className="selectable"
            sx={{
              whiteSpace: multiLine ? 'pre-line' : undefined,
              // minWidth 0 lets the value shrink below its longest word; break-word (not anywhere) keeps the <wbr /> the preferred break
              ...(wrapValue && { minWidth: 0, marginLeft: 'auto', textAlign: 'right', overflowWrap: 'break-word' }),
            }}
          >
            {value}
          </Typography>
        </Box>
        <Divider className="value-list-item-divider" sx={{ marginTop: 0.5, marginBottom: 0 }} />
      </VerticalBox>
    </ListItem>
  );
};
